const conf = {
    APP_ENV: 'production',
    ADAPTER: 'https://adapter.trainheroic.com',
    API: 'https://api.trainheroic.com',
    IS_PRODUCTION: true,
    URL_COACHHEROIC: 'https://coach.trainheroic.com/admin/coach#',
    BASE_URL_TEAMS: 'https://teams.trainheroic.com',
    BASE_URL_LIBRARY: 'https://library.trainheroic.com',
    BASE_URL_COACHAPP: 'https://coachapp.trainheroic.com',
    URL_ACCOUNT: 'https://account.trainheroic.com',
    URL_MARKETPLACE: 'https://marketplace.trainheroic.com',
    URL_FEEDBACK:
        'https://peaksware.uservoice.com/forums/942745-trainheroic-customer-feedback',
    URL_SUPPORT: 'https://support.trainheroic.com/hc/en-us',
    LOGIN: 'https://marketplace.trainheroic.com/account/login',
    ROLLBAR_ENV: 'coachApp-prod',
    SESSION_NAME: 'app-Session',
    SEGMENT_KEY: 'DpBWMDPr2mE4TckDB93DeO2NdJetmswa',
    AMBASSADOR_ID: '734a3122-d8cf-4c83-88b6-93407a46887b'
};

export default conf;
